<div class="milestone-events-container">
    <mat-card class="large-card">
        <div class="milestone-events-body-area">
            <div class="settings-heading">Milestones Management</div>
            <mat-tab-group
                (selectedTabChange)="handleTabChange($event)"
                ActiveTabIndex="activeTabIndex"
                useAutomaticActivation
            >
                <ng-container *ngFor="let tab of milestoneTabs">
                    <mat-tab [label]="tab.label"></mat-tab>
                </ng-container>
            </mat-tab-group>
            <div class="milestones-button-area">
                <div *ngFor="let tab of milestoneTabs">
                    <div class="milestones-button-sets" *ngIf="tab.tabIdex === activeTabIndex">
                        <button
                            mat-button
                            outlined
                            class="milestones-cacel-button"
                            (click)="clickCancel()"
                            [disabled]="tab.isCancelDisabled"
                        >
                            CANCEL
                        </button>
                        <button
                            mat-button
                            class="milestones-save-button"
                            [disabled]="tab.isSaveDisabled"
                            (click)="saveChanges()"
                        >
                            SAVE CHANGES
                        </button>
                    </div>
                </div>
            </div>
            <div>
                <ng-container *ngIf="activeTabIndex === 0">
                    <spin-loader *ngIf="loading" [type]="'spinner'"></spin-loader>
                    <div *ngIf="milestones">
                        <kendo-grid
                            [data]="gridData"
                            [height]="600"
                            [pageable]="false"
                            [skip]="state.skip"
                            [pageSize]="state.take"
                            class="lg-kendo-grid"
                        >
                            <kendo-grid-column
                                field="milestone"
                                title="Milestone"
                                [headerStyle]="getHeaderStyles()"
                                width="200"
                            >
                            </kendo-grid-column>
                            <kendo-grid-column
                                field="isActive"
                                title="Active"
                                [headerStyle]="getHeaderStyles()"
                                width="200"
                            >
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <p-checkbox
                                        [(ngModel)]="dataItem.isActive"
                                        class="checkbox welcomeEmail-button"
                                        (onChange)="checkBoxToggle($event, dataItem)"
                                        [disabled]="!dataItem.allowInactivate || !isAuthorisedUser"
                                        [binary]="true"
                                    />
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </ng-container>

                <ng-container *ngIf="activeTabIndex === 1">
                    <dragndrop-table
                        [dataObjectArray]="milestonesToSetOrder"
                        [isDragable]="isAuthorisedUser"
                        [resetData]="resetData"
                        [columnList]="columnList"
                        (emitModifidedObjectArray)="getReSortedArray($event)"
                        class="lg-kendo-grid"
                    >
                    </dragndrop-table>
                </ng-container>

                <ng-container *ngIf="activeTabIndex === 2">
                    <div class="primary-owner-tab">
                        <kendo-grid
                            [data]="primaryOwnerGridData"
                            [height]="600"
                            [pageable]="false"
                            [skip]="state.skip"
                            [pageSize]="state.take"
                            class="lg-kendo-grid"
                        >
                            <kendo-grid-column
                                field="milestone"
                                title="Milestone"
                                [headerStyle]="getHeaderStyles()"
                                width="200"
                            >
                            </kendo-grid-column>
                            <kendo-grid-column
                                field="staffPossition"
                                title="Primary Position/Role"
                                [headerStyle]="getHeaderStyles()"
                                width="200"
                            >
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <div class="primary-owner-select">
                                        <span
                                            *ngIf="
                                                !dataItem.allowSetPrimaryOwner || !isAuthorisedUser
                                            "
                                            >{{ dataItem.staffPosition }}</span
                                        >
                                        <select
                                            (ngModelChange)="modelChange($event, dataItem)"
                                            *ngIf="
                                                dataItem.allowSetPrimaryOwner && isAuthorisedUser
                                            "
                                            [(ngModel)]="dataItem.staffPositionKey"
                                        >
                                            <option
                                                *ngFor="let position of positionList"
                                                [value]="position.staffPositionKey"
                                            >
                                                {{ position.staffPosition }}
                                            </option>
                                        </select>
                                    </div>
                                </ng-template>
                            </kendo-grid-column>
                        </kendo-grid>
                    </div>
                </ng-container>
            </div>
        </div>
    </mat-card>
</div>
